export const ONBOARDING_COMPLETED_KEY = "inssa:onboarding:v1:completed";

export function hasCompletedFirstRunOnboarding() {
  try {
    return window.localStorage.getItem(ONBOARDING_COMPLETED_KEY) === "1";
  } catch {
    return false;
  }
}

export function markFirstRunOnboardingComplete() {
  try {
    window.localStorage.setItem(ONBOARDING_COMPLETED_KEY, "1");
  } catch {
    // If storage is unavailable, continue for the current session.
  }
}

export function clearFirstRunOnboardingForTests() {
  try {
    window.localStorage.removeItem(ONBOARDING_COMPLETED_KEY);
  } catch {
    // Test helper only.
  }
}
